export const dialog = {
  root: {
    background: 'rgba(45, 46, 55, 0.65)',
  },
  header: {
    padding: '0rem',
  },
  content: {
    padding: '0rem',
  },
}
